//Типы торгов
export const complaintTypes = [
    { value: "0", title: "Не устраивает менеджер" },
    { value: "1", title: "Другое" }
]